<template>
    <rkm-area
        background-color="warning"
        closed
        header-prefix-icon="pills"
        title="Medicamentos"
        type="box"
    >
        <rkm-row>
            <rkm-col cols="12">
                <rkm-list
                    :items="item.medicamentos"
                    hide-filters
                    hide-pagination
                >
                    <template v-slot="{item}">

                        <rkm-row>
                            <rkm-col cols="3">
                                <Item
                                    :get-value="() => item.medicamento"
                                    label="Descrição do medicamento"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <Item
                                    :get-value="() => item.qtdePresc"
                                    label="Quantidade prescrita"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <Item
                                    :get-value="() => item.uniMedPresc"
                                    label="Unidade de medida prescrita"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <Item
                                    :get-value="() => item.tipo"
                                    label="Tipo de material"
                                />
                            </rkm-col>
                        </rkm-row>
                    </template>
                </rkm-list>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

export default {    components: {

        Item
    },
    props: {
        item: {type: Object, required: true},
    },
}
</script>